var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78125 14.615C6.78125 15.4794 7.48203 16.1802 8.34645 16.1802H13.0421C13.0421 16.9006 13.6261 17.4845 14.3465 17.4845H15.9117C16.632 17.4845 17.216 16.9006 17.216 16.1802V14.615H6.78125Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3462 7.04858V10.7007C17.3462 11.2761 16.8781 11.7442 16.3027 11.7442V13.3094C17.7412 13.3094 18.9114 12.1392 18.9114 10.7007V7.04858H17.3462Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12942 10.7007C6.12942 11.2761 5.66133 11.7442 5.08594 11.7442V13.3094C6.52439 13.3094 7.69462 12.1392 7.69462 10.7007V7.04858H6.12942V10.7007Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5652 7.04858H15V10.7008H16.5652V7.04858Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6505 9.13555C12.6505 9.27941 12.5334 9.39641 12.3896 9.39641C12.2458 9.39641 12.1287 9.27936 12.1287 9.13555V7.04858H10.5635V9.13555C10.5635 9.27941 10.4465 9.39641 10.3027 9.39641C10.1589 9.39641 10.0418 9.27936 10.0418 9.13555V7.04858H8.47656V9.13555C8.47656 10.1425 9.29575 10.9617 10.3027 10.9617C10.6905 10.9617 11.0501 10.8398 11.3462 10.6328C11.6422 10.8397 12.0019 10.9617 12.3896 10.9617C12.4677 10.9617 12.5445 10.9562 12.62 10.9466C12.5091 11.4036 12.0976 11.7442 11.607 11.7442V13.3094C13.0455 13.3094 14.2157 12.1392 14.2157 10.7008V9.13555V7.04858H12.6505V9.13555H12.6505Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8244 11.7439H8.47656V13.3091H10.8244V11.7439Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SAR.ea5ae2a6f460a8f1fc43f51d9ea2801b.svg";